import { connectStats } from 'react-instantsearch-dom'
import { useTranslation } from 'react-i18next'
const Stats = ({
  nbHits,
  query,
  lang,
}: {
  nbHits: any
  query: any
  lang: any
}) => {
  const { t } = useTranslation()
  return (
    <div className="CustomStats">
      {t('shown')}
      {':'} {nbHits} {t('items')}
    </div>
  )
}

const CustomStats = connectStats(Stats)
export default CustomStats
